import React from "react";
import UserAvatar from "../../../shared_lib/custom/userAvatar/UserAvatar";

export const NavUser = ({
  user,
  setToggleSidebarHandler,
}: {
  user: any;
  setToggleSidebarHandler: () => void;
}) => {
  return (
    <>
      {/*<span className="user-label">
                <span className="primary">{`${user.firstname} ${user.lastname}`}</span>
              </span>*/}
      <UserAvatar
        user={`${user.firstname} ${user.lastname}`}
        clickHandler={setToggleSidebarHandler}
      />
    </>
  );
};
